import CircularProgress from '@mui/material/CircularProgress';
import React, { useEffect, useRef } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';

type P = {
  readMoreData(): void;
};

const Loading = ({ readMoreData }: P) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const entry = useIntersectionObserver(ref as React.RefObject<Element>, {});
  const isVisible = entry?.isIntersecting;

  useEffect(() => {
    isVisible && readMoreData();
  }, [isVisible]);
  return (
    <div
      ref={ref}
      style={{
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        height: '108px',
      }}
    >
      <CircularProgress size={'30px'} style={{ color: 'var(--dk-text-dim, #b7bbc2)' }} />
    </div>
  );
};

export default Loading;
